import React from 'react'
import styles from './FourOhFour.scss'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {Card} from 'common/styleguide/Card'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import {browserHistory} from 'react-router'

export class FourOhFour extends React.PureComponent {
  submitClicked = (e) => {
    if (window.zE) {
      e.preventDefault()
      window.zE('webWidget', 'show')
      window.zE('webWidget', 'open')
    }
  }

  render () {
    return (
      <StandardLayout greyBg>
        <div className={styles.FourOhFour}>
          <Card>
            <div className={styles.icon}>
              <Icon i='md-bicycle' size={50} />
            </div>
            <h2>The page you are looking for does not exist.</h2>
            <p style={{marginBottom: '20px'}}>If you expect something to be here, please submit a Support ticket. Thanks!</p>
            <div>
              <CTA inline margins={false} onClick={this.submitClicked} href='https://ridewithgps.zendesk.com/hc/en-us/requests/new'>Submit a Support Ticket</CTA>
              <CTA inline margins={false} link onClick={() => browserHistory.goBack()}>Go Back</CTA>
            </div>
          </Card>
        </div>
      </StandardLayout>
    )
  }
}
